import { getString } from './Functions'
import WL_SALANA from '../white_labels/salana.json'
import WL_DELAGOTT from '../white_labels/delagott.json'
import WL_CONZIGNUS from '../white_labels/conzignus.json'
import WL_HOMEPAL from '../white_labels/homepal.json'
import WL_SBC from '../white_labels/sbc.json'
import WL_BREDABLICK from '../white_labels/bredablick.json'
import WL_CASTOR from '../white_labels/castor.json'

export const COMMUNITY_STORAGE = 'project_x_community_storage'
export const USER_STORAGE = 'project_x_user_storage'
export const TOKEN_STORAGE = 'project_x_token_storage'

export const SALANA = 'salana'
export const HOMEPAL = 'homepal'
export const DELAGOTT = 'delagott'
export const SBC = 'sbc'
export const BREDABLICK = 'bredablick'
export const CONZIGNUS = 'conzignus'
export const CASTOR = 'castor'

export const WHITE_LABEL = WL_HOMEPAL
// export const WHITE_LABEL = WL_DELAGOTT

export const WIDTH = window.innerWidth

export const PASSED = 'passed'
export const TODAY = 'today'

export const SOCKET_URL = `${process.env.REACT_APP_API_URL}`

// Error reports
export const OPEN_ERROR_REPORT = 'open'
export const SOLVED_ERROR_REPORT = 'solved'
export const ARCHIVED_ERROR_REPORT = 'archived'

export const OPEN_ERROR_REPORTS = 'open_error_reports'
export const SOLVED_ERROR_REPORTS = 'solved_error_reports'
export const ARCHIVED_ERROR_REPORTS = 'archived_error_reports'

export const ERROR_REPORT_CHAT = 'chat'
export const ERROR_REPORT_EMAIL = 'email'

export const ERROR_REPORT_STATUSES = language => [
  { id: OPEN_ERROR_REPORTS, name: getString('openErrorReports', language) },
  {
    id: SOLVED_ERROR_REPORTS,
    name: getString('solvedErrorReports', language)
  },
  {
    id: ARCHIVED_ERROR_REPORTS,
    name: getString('closedErrorReports', language)
  }
]

export const MY_APARTMENT = 'my_apartment'
export const COMMON_AREA = 'common_area'
export const OUTSIDE = 'outside'
export const OTHER = 'other'

// COMMUNITY INFORMATION
export const PHONE = 'phone'
export const EMAIL = 'email'
export const URL = 'url'
export const TEXT = 'text'

//booking status
export const RED = 'red'
export const GREEN = 'green'

//URLS
export const APP_STORE_URL =
  'https://itunes.apple.com/se/app/norrsken-homes/id1364156245?l=en&mt=8'
export const GOOGLE_PLAY_URL =
  'https://play.google.com/store/apps/details?id=com.norrskenhomes'

export const NUMBER_OF_LAUNDRIES_ARRAY = [
  { id: 1, name: '1' },
  { id: 2, name: '2' },
  { id: 3, name: '3' },
  { id: 4, name: '4' },
  { id: 5, name: '5' },
  { id: 6, name: '6' },
  { id: 7, name: '7' },
  { id: 8, name: '8' },
  { id: 9, name: '9' },
  { id: 10, name: '10' }
]

export const WASHHOUSE_LAUNDRY_TYPE = {
  id: 'S',
  value: { SE: 'Tvättstuga', EN: 'Laundry room' }
}

export const MACHINE_LAUNDRY_TYPE = {
  id: 'M',
  value: { SE: 'Tvättmaskin', EN: 'Laundry Machine' }
}

export const HOURS_ARRAY = [
  { id: '00', name: '00' },
  { id: '01', name: '01' },
  { id: '02', name: '02' },
  { id: '03', name: '03' },
  { id: '04', name: '04' },
  { id: '05', name: '05' },
  { id: '06', name: '06' },
  { id: '07', name: '07' },
  { id: '08', name: '08' },
  { id: '09', name: '09' },
  { id: '10', name: '10' },
  { id: '11', name: '11' },
  { id: '12', name: '12' },
  { id: '13', name: '13' },
  { id: '14', name: '14' },
  { id: '15', name: '15' },
  { id: '16', name: '16' },
  { id: '17', name: '17' },
  { id: '18', name: '18' },
  { id: '19', name: '19' },
  { id: '20', name: '20' },
  { id: '21', name: '21' },
  { id: '22', name: '22' },
  { id: '23', name: '23' }
]

export const MINUTES_ARRAY = [
  { id: '00', name: '00' },
  { id: '05', name: '05' },
  { id: '10', name: '10' },
  { id: '15', name: '15' },
  { id: '20', name: '20' },
  { id: '25', name: '25' },
  { id: '30', name: '30' },
  { id: '35', name: '35' },
  { id: '40', name: '40' },
  { id: '45', name: '45' },
  { id: '50', name: '50' },
  { id: '55', name: '55' }
]

export const BOOKING_RANGE_ARRAY = (noLimit, week, weeks) => [
  { id: 0, name: noLimit },
  { id: 1, name: '1 ' + week },
  { id: 2, name: '2 ' + weeks },
  { id: 3, name: '3 ' + weeks },
  { id: 4, name: '4 ' + weeks },
  { id: 5, name: '5 ' + weeks },
  { id: 6, name: '6 ' + weeks },
  { id: 7, name: '7 ' + weeks },
  { id: 8, name: '8 ' + weeks },
  { id: 9, name: '9 ' + weeks },
  { id: 10, name: '10 ' + weeks }
]

export const MAX_BOOKING_ARRAY = (noLimit, washTime, washTimes) => [
  { id: 0, name: noLimit },
  { id: 1, name: '1 ' + washTime },
  { id: 2, name: '2 ' + washTimes },
  { id: 3, name: '3 ' + washTimes },
  { id: 4, name: '4 ' + washTimes },
  { id: 5, name: '5 ' + washTimes },
  { id: 6, name: '6 ' + washTimes },
  { id: 7, name: '7 ' + washTimes },
  { id: 8, name: '8 ' + washTimes },
  { id: 9, name: '9 ' + washTimes },
  { id: 10, name: '10 ' + washTimes }
]

export const AMOUNT_OF_APARTMENTS_ARRAY = [
  { id: 1, name: '1' },
  { id: 2, name: '2' },
  { id: 3, name: '3' },
  { id: 4, name: '4' },
  { id: 5, name: '5' },
  { id: 6, name: '6' },
  { id: 7, name: '7' },
  { id: 8, name: '8' },
  { id: 9, name: '9' },
  { id: 10, name: '10' },
  { id: 11, name: '11' },
  { id: 12, name: '12' },
  { id: 13, name: '13' },
  { id: 14, name: '14' },
  { id: 15, name: '15' },
  { id: 16, name: '16' },
  { id: 17, name: '17' },
  { id: 18, name: '18' },
  { id: 19, name: '19' },
  { id: 20, name: '20' },
  { id: 21, name: '21' },
  { id: 22, name: '22' },
  { id: 23, name: '23' },
  { id: 24, name: '24' },
  { id: 25, name: '25' },
  { id: 26, name: '26' },
  { id: 27, name: '27' },
  { id: 28, name: '28' },
  { id: 29, name: '29' },
  { id: 30, name: '30' },
  { id: 31, name: '31' },
  { id: 32, name: '32' },
  { id: 33, name: '33' },
  { id: 34, name: '34' },
  { id: 35, name: '35' },
  { id: 36, name: '36' },
  { id: 37, name: '37' },
  { id: 38, name: '38' },
  { id: 39, name: '39' },
  { id: 40, name: '40' },
  { id: 41, name: '41' },
  { id: 42, name: '42' },
  { id: 43, name: '43' },
  { id: 44, name: '44' },
  { id: 45, name: '45' },
  { id: 46, name: '46' },
  { id: 47, name: '47' },
  { id: 48, name: '48' },
  { id: 49, name: '49' },
  { id: 50, name: '50' },
  { id: 51, name: '51' },
  { id: 52, name: '52' },
  { id: 53, name: '53' },
  { id: 54, name: '54' },
  { id: 55, name: '55' },
  { id: 56, name: '56' },
  { id: 57, name: '57' },
  { id: 58, name: '58' },
  { id: 59, name: '59' },
  { id: 60, name: '60' },
  { id: 61, name: '61' },
  { id: 62, name: '62' },
  { id: 63, name: '63' },
  { id: 64, name: '64' },
  { id: 65, name: '65' },
  { id: 66, name: '66' },
  { id: 67, name: '67' },
  { id: 68, name: '68' },
  { id: 69, name: '69' },
  { id: 70, name: '70' },
  { id: 71, name: '71' },
  { id: 72, name: '72' },
  { id: 73, name: '73' },
  { id: 74, name: '74' },
  { id: 75, name: '75' },
  { id: 76, name: '76' },
  { id: 77, name: '77' },
  { id: 78, name: '78' },
  { id: 79, name: '79' },
  { id: 80, name: '80' },
  { id: 81, name: '81' },
  { id: 82, name: '82' },
  { id: 83, name: '83' },
  { id: 84, name: '84' },
  { id: 85, name: '85' },
  { id: 86, name: '86' },
  { id: 87, name: '87' },
  { id: 88, name: '88' },
  { id: 89, name: '89' },
  { id: 90, name: '90' },
  { id: 91, name: '91' },
  { id: 92, name: '92' },
  { id: 93, name: '93' },
  { id: 94, name: '94' },
  { id: 95, name: '95' },
  { id: 96, name: '96' },
  { id: 97, name: '97' },
  { id: 98, name: '98' },
  { id: 99, name: '99' },
  { id: 100, name: '100+' }
]

export const ONE_BUTTON = 'one_button'
export const TWO_BUTTONS = 'two_buttons'
export const THREE_BUTTONS = 'three_buttons'

export const BOOK_LAUNDRY_FOCUSED = 'book_laundry_focused'
export const MY_BOOKINGS_FOCUSED = 'my_bookings_focused'
export const REPORT_AN_ERROR_FOCUSED = 'report_an_error_focused'
export const INFO_BOARD_FOCUSED = 'info_board_focused'
export const MY_PAGE_FOCUSED = 'my_settings_focused'
export const NEWS_FOCUSED = 'new_focused'
export const BOOKING_SYSTEM_FOCUSED = 'booking_system_focused'
export const MY_BOOKING_SYSTEM_BOOKINGS_FOCUSED =
  'my_booking_system_bookings_focused'

export const WEEKDAYS_JS = ['su', 'mo', 'tu', 'we', 'th', 'fr', 'sa']



// WEBPACK FOOTER //
// ./src/helpers/Constants.js